export interface EnvironmentConfig {
  apiBaseUrl: string;
  registryDomain: string;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  // Default to development/local settings
  // let apiBaseUrl = 'https://registry.local:3000';
  // let registryDomain = 'registry.local:3000';
  let registryDomain = 'stage.terraform.acertus.io';
  let apiBaseUrl = 'https://stage.terraform.acertus.io';

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    if (hostname.includes('stage.registry.acertus.io')) {
      registryDomain = 'stage.terraform.acertus.io';
      apiBaseUrl = 'https://stage.terraform.acertus.io';
    } else if (hostname.includes('registry.acertus.io')) {
      registryDomain = 'terraform.acertus.io';
      apiBaseUrl = 'https://terraform.acertus.io';
    }
  }
  
  // Override with build-time environment variables if available
  if (import.meta.env.VITE_REGISTRY_DOMAIN) {
    registryDomain = import.meta.env.VITE_REGISTRY_DOMAIN;
    apiBaseUrl = `https://${import.meta.env.VITE_REGISTRY_DOMAIN}`;
  }
  
  if (import.meta.env.VITE_API_BASE_URL) {
    apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  }

  return {
    apiBaseUrl,
    registryDomain,
  };
};

export const environment = getEnvironmentConfig(); 